import {
  CheckCircleOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { Space, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
const { Text } = Typography;

const ActionMessageText = styled(Text)`
  font-size: 16px;
  line-height: 1.4;
`;
const ActionMessageIcon = styled.div`
  font-size: 32px;
  line-height: 1;
  color: ${props => props.theme.moduleDelegateColor};
`;

export interface IActionMessageProps {
  message?: string;
  type?: 'info' | 'success' | 'warning';
}

export function ActionMessage(props: IActionMessageProps) {
  const { message, type } = props;
  return (
    <Space>
      <ActionMessageIcon>
        {type === 'info' && <InfoCircleOutlined aria-hidden="true" />}
        {type === 'success' && <CheckCircleOutlined aria-hidden="true" />}
        {type === 'warning' && <WarningOutlined aria-hidden="true" />}
      </ActionMessageIcon>
      <ActionMessageText>{message}</ActionMessageText>
    </Space>
  );
}
